const _ = require("lodash");
const setIn = require("../ImmHelpers").setIn;

const settings = {
	allowRepeatTrials: true,
	staticMaxStars: true,
	noUndoRedoClear: true,
	neverSetOutcome: true,
	neverShowSliderMessages: true,
	saveAllProblems: true,
	starProgressType: "static",
	noProblemHistory: true,
	skipProblemCount: true,
};

const computeBackendTrial = function(result, problem, backendTrial) {
	return _.extend({}, backendTrial, {
		outcome: problem.customState.currentOutcome,
		response: {response: parseInt(_.last(backendTrial.response.response)[0])},
		problemData: {factors: _.take(backendTrial.response.response, 2)},
		final: true,
		attemptNumber: 1,
	});
};

const computeBackendProgress = function(result, defaultProgress) {
	return _.extend({}, defaultProgress, {
		problems: defaultProgress.problems.map(p =>
			setIn(
				p,
				"customState",
				_.omit(p.customState, ["solutionBatex", "trialCorrects"])
			)
		),
	});
};

const isCurrentProblemDone = function(result) {
	return isFinished(result);
};

// There's no way to get fewer than 3 stars.
const getStars = function(result) {
	return 3;
};

const initialize = function(result, processor) {
	const currentProblem = result.problems[0];
	currentProblem.customState = processor.setupCustomState(
		currentProblem.model,
		currentProblem.customState
	);
	currentProblem.model.initialPair = _.take(
		currentProblem.customState.trial,
		2
	);
};

const canGoToNextProblem = function(result) {
	return true;
};

// //This decides if a result should show instructions
// const showInstructionsOnNavigation = function(result) {
//   return true;
// };

const isFinished = function(result) {
	const currentProblem = result.problems[0];
	const customState = currentProblem.customState;

	//backwards compatibility
	if (customState.chart) {
		const unsolved = _.flatten(customState.chart).filter(b => !b);
		return !unsolved.length;
	}

	const chartSize = Math.pow(
		customState.numRange[1] - customState.numRange[0] + 1,
		2
	);
	const unsolvedSize = chartSize - customState.currentCorrectTrials.length;
	return !unsolvedSize;
};

const getPercentComplete = function(result) {
	const currentProblem = result.problems[0];
	const customState = currentProblem.customState;

	//backwards compatibility
	if (customState.chart) {
		const all = _.flatten(customState.chart);
		const numBlank = customState.numBlank || all.length;
		const solved = all.filter(b => b);
		const minToCount = customState.submissions ? 1 : 0; //Count at least 1 if at least 1 submission
		return (
			Math.max(solved.length - all.length + numBlank, minToCount) / numBlank
		);
	}

	const chartSize = Math.pow(
		customState.numRange[1] - customState.numRange[0] + 1,
		2
	);
	const solvedSize = customState.currentCorrectTrials.length;
	const numBlank = customState.numBlank || chartSize;
	const minToCount = customState.submissions ? 1 : 0; //Count at least 1 if at least 1 submission
	return Math.max(solvedSize - chartSize + numBlank, minToCount) / numBlank;
};

const processPostSubmission = function(result, processor) {
	const currentProblem = result.problems[0];
	const problemModel = currentProblem.model;
	const customState = currentProblem.customState;
	const newCustomState = processor.updateCustomStatePostSubmission(
		problemModel,
		customState,
		currentProblem.trials
	);
	return setIn(result, ["problems", 0, "customState"], newCustomState);
};

const getTrialXP = function(result) {
	return 1;
};

const getResultProgressXP = function(backendResult) {
	const {progress} = backendResult;
	const numCorrect = _.get(progress, "problems.0.customState.numCorrect") || 0;
	return numCorrect * getTrialXP();
};

const getSummaryProblemsSolvedText = function(result) {
	return "";
};

const getStarProgressInfo = function(result) {
	return {
		styleType: result.styleType,
		filledAmount: getPercentComplete(result),
		totalAmount: 1,
		starsAvailable: result.starsAvailable,
		starsEarned: isFinished(result) ? result.starsAvailable : 0,
	};
};

const getSummaryForReport = function(backendResult) {
	const trials = _.get(backendResult, "progress.problems[0].trials");
	if (!trials) {
		return "Problems cannot be displayed for this game lesson.";
	} else {
		const numCorrect = _.get(
			backendResult,
			"progress.problems[0].customState.numCorrect"
		);
		if (_.isInteger(numCorrect)) {
			return `${numCorrect}/${trials.length} problems answered correctly.`;
		} else {
			return `${trials.length} problems answered.`;
		}
	}
};

module.exports = {
	settings,
	computeBackendTrial,
	computeBackendProgress,
	isCurrentProblemDone,
	initialize,
	canGoToNextProblem,
	isFinished,
	getResultProgressXP,
	getPercentComplete,
	processPostSubmission,
	getTrialXP,
	getStars,
	getSummaryProblemsSolvedText,
	getStarProgressInfo,
	getSummaryForReport,
};
